import React from 'react'
import { useListingBreadcrumbs } from '@sentecacommerce-theme/lib'
import { Breadcrumbs } from '../../../Common'

export const BreadcrumbContainer = ({
  isCentered,
  isInError,
}: {
  isCentered?: boolean
  isInError?: boolean
}) => {
  const { data: breadcrumbData } = useListingBreadcrumbs()
  return (
    <div>
      {breadcrumbData && (
        <div className="d-none d-lg-block">
          <Breadcrumbs
            isCentered={isCentered}
            isInError={isInError}
            isLoading={false}
            data={breadcrumbData}
          />
        </div>
      )}
    </div>
  )
}
